// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202611041257/js/" + chunkId + "." + {"44":"15cebc2b","225":"ed5b5573","481":"2177d818","486":"b4307f7d","770":"8fc874ba"}[chunkId] + ".0.7889789526104203.chunk.js";
};